import React from "react";
import student2 from "../../img/figure/student2.png";
import student3 from "../../img/figure/student3.png";
import student4 from "../../img/figure/student4.png";
import student5 from "../../img/figure/student5.png";
import $ from "jquery";
import Cta from "../../Shared/Cta";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const AllParent = () => {
  useEffect(() => {
    $(".checkAll").on("click", function () {
      $(this)
        .parents(".table")
        .find("input:checkbox")
        .prop("checked", this.checked);
    });
  }, []);
  return (
    <>
      <div class="breadcrumbs-area">
        <h3>Parents</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>All Parents</li>
        </ul>
      </div>

      <div class="card height-auto">
        <div class="card-body">
          <div class="heading-layout1">
            <div class="item-title">
              <h3>All Parents Data</h3>
            </div>
            <Cta />
          </div>
          <form class="mg-b-20">
            <div class="row gutters-8">
              <div class="col-3-xxxl col-xl-3 col-lg-3 col-12 form-group">
                <input
                  type="text"
                  placeholder="Search by ID ..."
                  class="form-control"
                />
              </div>
              <div class="col-4-xxxl col-xl-4 col-lg-3 col-12 form-group">
                <input
                  type="text"
                  placeholder="Search by Name ..."
                  class="form-control"
                />
              </div>
              <div class="col-4-xxxl col-xl-3 col-lg-3 col-12 form-group">
                <input
                  type="text"
                  placeholder="Search by Phone ..."
                  class="form-control"
                />
              </div>
              <div class="col-1-xxxl col-xl-2 col-lg-3 col-12 form-group">
                <button type="submit" class="fw-btn-fill btn-gradient-yellow">
                  SEARCH
                </button>
              </div>
            </div>
          </form>
          <div class="table-responsive">
            <table class="table display data-table text-nowrap">
              <thead>
                <tr>
                  <th>
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input checkAll"
                      />
                      <label class="form-check-label">ID</label>
                    </div>
                  </th>
                  <th>Photo</th>
                  <th>Name</th>
                  <th>Gender</th>
                  <th>Occupation</th>
                  <th>Address</th>
                  <th>Phone</th>
                  <th>E-mail</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0021</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student2} alt="student" />
                  </td>
                  <td>Mark Willy</td>
                  <td>Male</td>
                  <td>Businessman</td>
                  <td>TA-107 Newyork</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0022</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student3} alt="student" />
                  </td>
                  <td>Jessia Rose</td>
                  <td>Female</td>
                  <td>House Wife</td>
                  <td>59 Australia, Sydney</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0023</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student4} alt="student" />
                  </td>
                  <td>Mark Willy</td>
                  <td>Male</td>
                  <td>Banker</td>
                  <td>TA-107 Newyork</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0024</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student5} alt="student" />
                  </td>
                  <td>Jessia Rose</td>
                  <td>Female</td>
                  <td>House Wife</td>
                  <td>59 Australia, Sydney</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0025</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student2} alt="student" />
                  </td>
                  <td>Mark Willy</td>
                  <td>Male</td>
                  <td>Businessman</td>
                  <td>TA-107 Newyork</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0026</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student3} alt="student" />
                  </td>
                  <td>Jessia Rose</td>
                  <td>Female</td>
                  <td>Banker</td>
                  <td>59 Australia, Sydney</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0027</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student4} alt="student" />
                  </td>
                  <td>Mark Willy</td>
                  <td>Male</td>
                  <td>Businessman</td>
                  <td>TA-107 Newyork</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0028</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student5} alt="student" />
                  </td>
                  <td>Jessia Rose</td>
                  <td>Female</td>
                  <td>Banker</td>
                  <td>59 Australia, Sydney</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0029</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student2} alt="student" />
                  </td>
                  <td>Mark Willy</td>
                  <td>Male</td>
                  <td>House Wife</td>
                  <td>TA-107 Newyork</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0030</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student2} alt="student" />
                  </td>
                  <td>Jessia Rose</td>
                  <td>Female</td>
                  <td>Banker</td>
                  <td>59 Australia, Sydney</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0021</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student2} alt="student" />
                  </td>
                  <td>Mark Willy</td>
                  <td>Male</td>
                  <td>Businessman</td>
                  <td>TA-107 Newyork</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0021</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student2} alt="student" />
                  </td>
                  <td>Mark Willy</td>
                  <td>Male</td>
                  <td>Businessman</td>
                  <td>TA-107 Newyork</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0022</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student3} alt="student" />
                  </td>
                  <td>Jessia Rose</td>
                  <td>Female</td>
                  <td>House Wife</td>
                  <td>59 Australia, Sydney</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0023</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student4} alt="student" />
                  </td>
                  <td>Mark Willy</td>
                  <td>Male</td>
                  <td>Banker</td>
                  <td>TA-107 Newyork</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0024</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student5} alt="student" />
                  </td>
                  <td>Jessia Rose</td>
                  <td>Female</td>
                  <td>House Wife</td>
                  <td>59 Australia, Sydney</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0025</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student2} alt="student" />
                  </td>
                  <td>Mark Willy</td>
                  <td>Male</td>
                  <td>Businessman</td>
                  <td>TA-107 Newyork</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0026</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student3} alt="student" />
                  </td>
                  <td>Jessia Rose</td>
                  <td>Female</td>
                  <td>Banker</td>
                  <td>59 Australia, Sydney</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0027</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student4} alt="student" />
                  </td>
                  <td>Mark Willy</td>
                  <td>Male</td>
                  <td>Businessman</td>
                  <td>TA-107 Newyork</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0028</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student5} alt="student" />
                  </td>
                  <td>Jessia Rose</td>
                  <td>Female</td>
                  <td>Banker</td>
                  <td>59 Australia, Sydney</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0029</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student2} alt="student" />
                  </td>
                  <td>Mark Willy</td>
                  <td>Male</td>
                  <td>House Wife</td>
                  <td>TA-107 Newyork</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0030</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student2} alt="student" />
                  </td>
                  <td>Jessia Rose</td>
                  <td>Female</td>
                  <td>Banker</td>
                  <td>59 Australia, Sydney</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0021</label>
                    </div>
                  </td>
                  <td class="text-center">
                    <img src={student2} alt="student" />
                  </td>
                  <td>Mark Willy</td>
                  <td>Male</td>
                  <td>Businessman</td>
                  <td>TA-107 Newyork</td>
                  <td>+ 123 9988568</td>
                  <td>kazifahim93@gmail.com</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllParent;
